const pages = {
  home: {
    ID: "home",
    route: "/",
  },

  eventListPage: {
    ID: "EventList",
    route: "/event-list",
  },

  appointment: {
    ID: "appointment",
    route: "/login",
  },

  TrackAppointment: {
    ID: "TrackAppointment",
    route: "/track-appointment",
  },

  ContactUs: {
    ID: "ContactUs",
    route: "/contact-us",
  },

  SignIn: {
    ID: "signIn",
    route: "/sign-in",
  },

  SignUp: {
    ID: "signUp",
    route: "/sign-up",
  },

  AboutUs: {
    ID: "AboutUs",
    route: "/about-us",
  },

  previewVideo: {
    ID: "previewVideo",
    route: "/previewVideo",
  },

  checkLiveliness: {
    ID: "liveliness",
    route: "/face-verification",
  },

  Success: {
    ID: "Success",
    route: "/success",
  },

  Error: {
    ID: "Error",
    route: "/error",
  },

  Error500: {
    ID: "Error500",
    route: "/error-500",
  },

  Verification: {
    ID: "Verification",
    route: "/verification",
  },

  CampusVerification: {
    ID: "CampusVerification",
    route: "/campus/verification",
  },

  AppointmentVerification: {
    ID: "AppointmentVerification",
    route: "/appointment/verification",
  },

  AadharverificaionDetails: {
    ID: "AadharverificaionDetails",
    route: "/aadhar-verificaion-details",
  },

  AadharverificaionSuccess: {
    ID: "AadharverificaionSuccess",
    route: "/aadhar-verificaion-success",
  },

  DrivingLicenceDetails: {
    ID: "DrivingLicenceDetails",
    route: "/driving-licence-details",
  },

  UploadDocument: {
    ID: "UploadDocument",
    route: "/upload-document",
  },

  EventBooking: {
    ID: "EventBooking",
    route: "/event/event-booking",
  },

  AppointmentBooking: {
    ID: "AppointmentBooking",
    route: "/appointment/appointment-booking",
  },

  IndependentAppointmentBooking: {
    ID: "IndependentAppointmentBooking",
    route: "/independent/appointment-booking",
  },

  EventBookingDetails: {
    ID: "EventBookingDetails",
    route: "/event/event-booking-details",
  },

  AppointmentBookingDetail: {
    ID: "AppointmentBooking",
    route: "/appointment-booking-details",
  },

  BioVerificaion: {
    ID: "AppointmentBooking",
    route: "/bio-verification",
  },

  MainGateEntryWithFrontCamera: {
    ID: "MainGateEntryWithFrontCamera",
    route: "/main-gate-entry-front",
  },

  MainGateEntryWithBackCamera: {
    ID: "MainGateEntryWithBackCamera",
    route: "/main-gate-entry-back",
  },

  MainGateEntrySuccess: {
    ID: "MainGateEntrySuccess",
    route: "/main-gate-entry-success",
  },

  ManualEntry: {
    ID: "ManualEntry",
    route: "/manual-entry",
  },

  ManualVerification: {
    ID: "ManualVerification",
    route: "/manual-verification",
  },

  ResendNotification: {
    ID: "ResendNotification",
    route: "/resend-notification",
  },

  PhotoVerification: {
    ID: "PhotoVerification",
    route: "/photo-verification",
  },

  DocVerification: {
    ID: "DocVerification",
    route: "/doc-verification",
  },

  Consent: {
    ID: "Consent",
    route: "/event/consent",
  },

  AppointmentConsent: {
    ID: "appointmentConsent",
    route: "/appointment/consent",
  },

  BoardingPass: {
    ID: "BoardingPass",
    route: "/boarding-pass",
  },

  ShopsMore: {
    ID: "ShopsMore",
    route: "/shops-more",
  },

  Shops: {
    ID: "Shops",
    route: "/shops",
  },

  Hotels: {
    ID: "Hotels",
    route: "/hotels",
  },

  Shop: {
    ID: "Shops",
    route: "/shop",
  },

  Hotel: {
    ID: "Hotel",
    route: "/hotel",
  },

  Transaction: {
    ID: "Transaction",
    route: "/transaction",
  },

  Profile: {
    ID: "Profile",
    route: "/profile",
  },

  HotelBookingPage: {
    ID: "HotelBookingPage",
    route: "/hotel-booking",
  },

  AddHotelBookingPage: {
    ID: "AddHotelBookingPage",
    path: "/add-hotel-booking",
  },

  EventPage: {
    ID: "Event",
    path: "/event",
  },

  eventInviteUserPage: {
    ID: "eventInviteUser",
    path: "event/invite-user/",
  },

  appointmentInviteUserPage: {
    ID: "appointmentInviteUser",
    path: "appointment/invite-user/",
  },

  InviteUserPage: {
    ID: "InviteUser",
    path: "/hotel/invite-user",
  },

  HotelVerification: {
    ID: "HotelVerification",
    route: "/hotel/verification",
  },
  //
  HotelConsent: {
    ID: "HotelConsent",
    route: "/hotel/consent",
  },

  OutingPage: {
    ID: "OutingPage",
    route: "/outing-page",
  },

  OutingPassListPage: {
    ID: "OutingPassListPage",
    route: "/outing-pass-list-page",
  },

  CampusUserPage: {
    ID: "CampusUserPage",
    route: "/campus-user",
  },

  CheckInPage: {
    ID: "CheckInPage",
    route: "/check-in",
  },

  EventSummary: {
    ID: "EventSummary",
    route: "/event/summary/",
  },

  AppointmentSummary: {
    ID: "AppointmentSummary",
    route: "/appointment/summary",
  },

  IndependentAppointmentSummary: {
    ID: "IndependentAppointmentSummary",
    route: "/independent-appointment/summary",
  },

  CampusSummary: {
    ID: "CampusSummary",
    route: "/campus/summary",
  },

  HotelSummary: {
    ID: "HotelSummary",
    path: "/hotel/summary/",
  },

  EntrySummary: {
    ID: "EntrySummary",
    route: "/entry/summary/",
  },

  AutoGateOpen: {
    ID: "AutoGateOpen",
    route: "/auto-gate-open",
  },

  MeetingRoomList: {
    ID: "MeetingRoomList",
    route: "/meeting-room-list",
  },

  AddBooking: {
    ID: "AddBooking",
    route: "/add-booking",
  },

  BookingStats: {
    ID: "  BookingStats",
    route: "/booking-stats",
  },

  EventSuccess: {
    ID: "EventSuccess",
    route: "/event-success",
  },

  studentProfile: {
    ID: "StudentProfile",
    route: "/student-profile",
  },

  appointmentRequest: {
    ID: "appointmentRequest",
    route: "/appointment-request",
  },

  guardianRequest: {
    ID: "guardianRequest",
    route: "/guardian-request",
  },

  videoLiveliness: {
    ID: "liveliness",
    route: "/liveness",
  },

  previewLivelinessVideo: {
    ID: "previewLivelinessVideo",
    route: "/preview-liveliness-video",
  },

  WardenFlow: {
    ID: "WardenFlow",
    route: "/warden-flow",
  },

  GuardFlow: {
    ID: "GuardFlow",
    route: "/guard-flow",
  },

  GuardUserDetails: {
    ID: "GuardUserDetails",
    route: "/guard-user-details",
  },

  ScanQR: {
    ID: "ScanQR",
    route: "/scan-qr",
  },
  GuestVerification: {
    ID: "GuestVerification",
    route: "/guest-verification",
  },

  SettingsPage: {
    ID: "SettingsPage",
    route: "/settings",
  },

  DependentsPage: {
    ID: "DependentsPage",
    route: "/dependents",
  },

  EmployeeDetailsPage: {
    ID: "EmployeeDetailsPage",
    route: "/employee-details",
  },

  GuardiansPage: {
    ID: "GuardiansPage",
    route: "/guardians",
  },

  ParkingPage: {
    ID: "ParkingPage",
    route: "/parking",
  },

  VisitorSignUp: {
    ID: "visitorSignUp",
    route: "/visitor-sign-up",
  },

  gateEntryRequest: {
    ID: "gateEntryRequest",
    route: "/gate-entry-request",
  },

  appointmentList: {
    ID: "AppointmentList",
    route: "/appointment-list",
  },

  AddAdmission: {
    ID: "AddAdmission",
    route: "/add-admission",
  },

  SecureMeeting: {
    ID: "SecureMeeting",
    route: "/secure-meeting",
  },
};

export default pages;
